"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("linaria/react");

const Layout =
/*#__PURE__*/
(0, _react.styled)("div")({
  name: "Layout",
  class: "Layout_lugqar2"
});
var _default = Layout;
exports.default = _default;
//# sourceMappingURL=Layout.js.map

require('../css/src/templates/Layout.css');
